import * as React from "react";
import {
  chakra,
  ImageProps,
  forwardRef,
  useColorMode,
  Flex,
  Image,
} from "@chakra-ui/react";
import logo from "./logo.svg";
import logoWhite from "./logo-white.svg";
import dollar from "./dollar.svg";
import dollarWhite from "./dollar-white.svg";

export const Logo = forwardRef<ImageProps, "img">((props, ref) => {
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <Flex>
      <Image w={"70px"} src={colorMode === "light" ? dollar : dollarWhite} />
      <chakra.img
        src={colorMode === "light" ? logo : logoWhite}
        ref={ref}
        {...props}
      />
    </Flex>
  );
});
